'use client'

import { TimerOff } from 'lucide-react'

import { useFlow } from '@/shared/lib/steps-flow'
import { Button } from '@/shared/ui/Button'

import { HUD } from './HUD'

export function StepTimeOver() {
  const { reset } = useFlow()

  const handleRestart = reset

  return (
    <HUD.Root>
      <HUD.Card>
        <HUD.Header>Tempo esgotado</HUD.Header>
        <HUD.Body className="row-span-2">
          <div className="min-h-[250px] rounded-2xl bg-jacaranda/20 p-6 flex flex-col items-center justify-center">
            <TimerOff
              className="mb-4 h-12 w-12 text-orange-600"
              aria-hidden="true"
            />
            <span className="mb-2 text-center text-xl font-bold text-orange-800">
              É uma pena, mas seu tempo de resposta acabou!
            </span>
            <span className="mb-8 text-center text-sm text-gray-500">
              Tente novamente para conquistar este nível.
            </span>
          </div>
        </HUD.Body>
        <HUD.Footer>
          <Button variant="primary" onClick={handleRestart} className="flex-1">
            Tentar mais uma vez
          </Button>
        </HUD.Footer>
      </HUD.Card>
    </HUD.Root>
  )
}
